import { Sparkles, Users } from 'lucide-react'
import { cn } from '@/lib/utils'

interface CharterCollaborationPanelProps {
  type: 'prep' | 'group'
  isConnected: boolean
  activeAgent?: 'prep' | 'group'
  onAgentChange?: (agent: 'prep' | 'group') => void
  hidePrepTab?: boolean
}

export function CharterCollaborationPanel({
  type,
  isConnected,
  activeAgent = type === 'prep' ? 'prep' : 'group',
  onAgentChange,
  hidePrepTab = false,
}: CharterCollaborationPanelProps) {
  const allTabs =
    type === 'prep'
      ? [{ id: 'prep' as const, label: 'Preparation Coach', Icon: Sparkles }]
      : [
          { id: 'prep' as const, label: 'Preparation Coach', Icon: Sparkles },
          { id: 'group' as const, label: 'Group Moderator', Icon: Users },
        ]
  const tabs = hidePrepTab ? allTabs.filter((t) => t.id !== 'prep') : allTabs

  return (
    <div className='flex flex-col h-full overflow-hidden bg-[#FAFCFF]'>
      <div className='flex-1 min-h-0 overflow-y-auto px-2 py-3 space-y-4'>
        <section>
          <p className='mb-2 px-1 text-sm font-semibold text-gray-700'>Channels</p>
          <div className='space-y-1'>
            {tabs.map(({ id, label, Icon }) => {
              const isActive = activeAgent === id
              const isLive = type === 'group' && id === 'group'
              return (
                <button
                  key={id}
                  onClick={() => onAgentChange?.(id)}
                  className={cn(
                    'w-full flex items-center rounded-md transition-all duration-200 h-9 justify-between px-3',
                    isActive
                      ? 'bg-[#E6ECF2] text-slate-900 hover:bg-[#DDE6F0] border-r-2 border-[#B9C8D8]'
                      : 'text-slate-600 hover:bg-slate-100'
                  )}
                >
                  <div className='flex items-center gap-2 min-w-0 flex-1'>
                    <div className={cn('flex-shrink-0', isActive ? 'text-slate-900' : 'text-slate-500')}>
                      <Icon className='w-3.5 h-3.5' />
                    </div>
                    <span className='truncate text-sm font-semibold'>{label}</span>
                  </div>
                  {isLive && (
                    <span
                      className={cn(
                        'w-2 h-2 rounded-full flex-shrink-0',
                        isConnected ? 'bg-emerald-400' : 'bg-amber-400'
                      )}
                      title={isConnected ? 'Connected' : 'Connecting…'}
                    />
                  )}
                </button>
              )
            })}
          </div>
        </section>
      </div>

    </div>
  )
}
